import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import useMediaQuery from '@mui/material/useMediaQuery';
import { ChartSelectorDisplay } from '../components/chartSelectorDisplay';
import './GraphSelectorPage.css';
import { useRockbashAccuracy, useUserRole } from '../api/GetData';
import DialChart from "../components/DialChart";
const GraphSelectorPage = ({ pageKey }) => {
    const plantName = typeof pageKey === "string" && pageKey.startsWith("CustomerPersona:")
      ? pageKey.slice("CustomerPersona:".length)
      : null;
    // Original values
    const isDesktop = useMediaQuery("(min-width:720.9px)")
    const [accuracy, setAccuracy] = useState(0)
    const [bidAccuracy, setBidAccuracy] = useState(0)
    // Placeholder 24-hour values (for now same as above)
    const [accuracy24h, setAccuracy24h] = useState(0)
    const [bidAccuracy24h, setBidAccuracy24h] = useState(0)
    const { isPending, isError, data, error } = useRockbashAccuracy()
    const {data:userProfile} = useUserRole()
    const role = (userProfile || '').toLowerCase()
    
    
    const [selectedCharts, setSelectedCharts] = useState({});
    const defaultCharts = {
      short_forecast: true,
      short_forecast_store_models: true,
      pool_price: true,
      pool_price_store_models: true,
      accuracy_histogram: true,
      generation: true,
      sevenD_accuracy: true,
      quantify_beta: true,
      revenue: true,
      ST_supply: true,
      LT_rockbash: true,
      LT_supply: true,
      total_generation: true,
      gross_profit: true,
      market_offers_optimized: true,
      accuracy_dials: true,
      current_supply_demand: true,
    };
    const chartLabelMap = {
      short_forecast: "Short Term Forecast",
      short_forecast_store_models: "Short Term Forecast - Store Models",
      pool_price: "Pool Price",
      pool_price_store_models: "Pool Price - T+3 Store Models",
      accuracy_histogram: "Accuracy Histogram",
      generation: "Current Metered Volume / Forecasted Demand",
      sevenD_accuracy: "7-Day Accuracy Trend",
      quantify_beta: "Quantify Beta",
      revenue: "Revenue",
      ST_supply: "Short Term Supply",
      LT_rockbash: "Long Term Forecast",
      LT_supply: "Long Term Supply",
      total_generation: "Current Supply / Long Term Supply",
      gross_profit: "Gross Profit",
      market_offers_optimized: "Optimized Market Offers Submitted",
      accuracy_dials: "Accuracy Dials",
      current_supply_demand: "Current Supply / Demand",
    };
    const getChartLabel = (key) => chartLabelMap[key] || key.replace(/_/g, " ").replace(/\b\w/g, (m) => m.toUpperCase());
    useEffect(() => {
        const saved = localStorage.getItem(pageKey);
        if (saved) {
            try {
                const parsed = JSON.parse(saved);
                setSelectedCharts({ ...defaultCharts, ...parsed });
                return;
            } catch (error) {
                console.error("Failed to parse saved chart settings:", error);
            }
        }
        setSelectedCharts(defaultCharts);
    }, [pageKey]);

  // Toggle chart and save to localStorage
  const toggleChart = (chartName) => {
    setSelectedCharts((prev) => {
      const updated = { ...prev, [chartName]: !prev[chartName] };
      localStorage.setItem(pageKey, JSON.stringify(updated));
      return updated;
    });
  };
   
    useEffect(() => {
        if(role=="dev" && Array.isArray(data) && data.length > 0) {
            const latest = data[0] || {};
            setAccuracy(Number(latest.avg_accuracy || 0));
            setBidAccuracy(Number(latest.bid_accuracy_true || 0));
            setAccuracy24h(Number(latest.avg_accuracy_24h || 0));
            setBidAccuracy24h(Number(latest.bid_accuracy_true_24h || 0));
        } else if (role=="dev" && (!Array.isArray(data) || data.length===0)) {
            setAccuracy(0);
            setBidAccuracy(0);
            setAccuracy24h(0);
            setBidAccuracy24h(0);
        }
    }, [data, role]);

    useEffect(() => {
        if (isPending) {
            console.log('[accuracyDials] loading...');
            return;
        }
        if (isError) {
            console.log('[accuracyDials] error:', error);
            return;
        }
        if (Array.isArray(data)) {
            console.log('[accuracyDials] rows:', data.length, 'latest:', data[0]);
        } else {
            console.log('[accuracyDials] unexpected payload:', data);
        }
    }, [isPending, isError, data, error]);
    

    return (
        <div style={{ backgroundColor: "#0b1422", minHeight: "100vh", padding: "12px" }}>
                    {/* Top bar showing accuracy metrics */}
                    {isDesktop && role === "dev" &&(
                    <div style={{display: 'flex', justifyContent: 'space-around', alignItems: 'center', backgroundColor: 'transparent', padding: '5px', borderRadius: '8px', marginBottom: '10px', flexWrap: 'wrap', boxShadow: 'none', border: 'none' }}>
                        <DialChart title="Accuracy" value={Number(accuracy)} size={100} arrow="up" maxValue={400}/>
                        <DialChart title="Bid Accuracy" value={Number(bidAccuracy)} size={100} arrow="up" maxValue={100}/>
                        <button onClick={() => toggleChart('accuracy_dials')}
                            style={{padding: "8px 16px",
                            borderRadius: "8px",
                            border: "1px solid #ccc",
                            backgroundColor: selectedCharts['accuracy_dials'] ? "#4caf50" : "#0b1422",
                            color: selectedCharts['accuracy_dials'] ? "#fff" : "#e7edf7",
                            cursor: "pointer",
                            fontWeight: "bold",}}>
                                {selectedCharts['accuracy_dials'] ? "Hide" : "Show"} {getChartLabel('accuracy_dials')}
                        </button>
                        <DialChart title="24h Accuracy" value={Number(accuracy24h)} size={100} arrow="up" maxValue={400}/>
                        <DialChart title="24h Bid Accuracy" value={Number(bidAccuracy24h)} size={100} arrow="up" maxValue={100}/>
                    </div>
                    )}
                    <Box sx={{display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap:2, marginY: 0}}>
                                  {Object.keys(selectedCharts).filter(chart => (chart !== 'short_forecast_store_models' && chart !== 'pool_price_store_models') || role === 'dev').map((chart) => (
                        <button key={chart} onClick={() => toggleChart(chart)}
                        style={{padding: "8px 16px",
                        borderRadius: "8px",
                        border: "1px solid #ccc",
                        backgroundColor: selectedCharts[chart] ? "#4caf50" : "#0b1422",
                        color: selectedCharts[chart] ? "#fff" : "#e7edf7",
                        cursor: "pointer",
                        fontWeight: "bold",}}>
                            {selectedCharts[chart] ? "Hide" : "Show"} {getChartLabel(chart)}
                        </button>
                    ))}
                    </Box>
                    <Box className='box-left'  sx={{
                        height: '77vh',       
                        overflowY: 'auto',    
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fit, minmax(500px, 1fr))',
                        gap: 2,
                        margin: '20px 0',
                        scrollbarWidth: "none", // Firefox (Hidden Scrolling)
                        "&::-webkit-scrollbar": { display: "none" }, // Chromium, Safari
                        backgroundColor: "#0b1422",
                        border: "1px solid #22416b",
                        borderRadius: "10px",
                        padding: "8px",
                        }}>
                        <ChartSelectorDisplay selectedCharts={selectedCharts} plantName={plantName}/>
                    </Box>
                
        </div>
    );
};

export default GraphSelectorPage;
